import { Dropdown } from "react-bootstrap";
import { useState } from "react";
import "./styles.scss";
import { helpLinks } from "shared/app-config";
import { HiOutlineChartPie } from "react-icons/hi2";
import { BsInfoCircle } from "react-icons/bs";
import { AiOutlinePoweroff } from "react-icons/ai";
import Avatar from "react-avatar";
import React, { forwardRef } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaRegCircleUser } from "react-icons/fa6";
import { FiBookOpen } from "react-icons/fi";
import { AiOutlinePlayCircle } from "react-icons/ai";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";

const IconToggle = forwardRef(({ onClick }, ref) => (
  <span
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    role="button"
    tabIndex={0}
    onKeyDown={(e) => {
      if (e.key === "Enter") onClick(e);
    }}
    className="d-flex align-items-center gap-2"
    style={{ cursor: "pointer" }}
  >
    <OverlayTrigger placement="left" overlay={ <Tooltip id="help-tooltip"> Help </Tooltip> } >
      <span style={{ cursor: "pointer" }}>
        <BsInfoCircle size="1.5rem" />
      </span>
    </OverlayTrigger>
  </span>
));
const HeaderOptions = ({ user, logout, setShowReport, isAdmin }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isHelpOpen, setIsHelpOpen] = useState(false);

  return (
    <div className="d-flex align-items-center gap-4 header-option">
     <Dropdown align="end" className="d-none d-lg-block">
        <Dropdown.Toggle as={IconToggle} />
        <Dropdown.Menu className="rounded-3 shadow-lg border-0">
          <Dropdown.Item href={helpLinks.USER_GUIDE} target="_blank">
            <FiBookOpen className="mx-1"/> Hello User Guide
          </Dropdown.Item>
          <Dropdown.Divider/>
          <Dropdown.Item href={helpLinks.VIDEO_GUIDE} target="_blank">
            <AiOutlinePlayCircle className="mx-1"/>Hello Video Guide
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      <Dropdown align="end" show={isOpen} onToggle={(nextShow) => setIsOpen(nextShow)}>
        <Dropdown.Toggle variant="info" className="option-dropdown-toggle d-flex align-items-center gap-2 py-1 px-2 bg-avtar">
          <div className="d-none d-lg-flex align-items-center gap-2">
            <FaRegCircleUser />
            <span className="fw-normal">{user?.given_name}</span>
            {isOpen ? (
              <IoIosArrowUp  size="0.9rem" />
            ) : (
              <IoIosArrowDown  size="0.9rem" />
            )}
          </div>
          <div className="d-flex d-lg-none align-items-center ms-2">
            <Avatar name={user?.given_name + " " + user?.family_name} size="42" round color="#0d6efd" style={{ fontWeight: "normal", fontFamily: "inherit" }} textSizeRatio={2}/>
            {/* {isOpen ? (
              <FaCaretUp className="" size="0.9rem" />
            ) : (
              <FaCaretDown className="" size="0.9rem" />
            )} */}
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className="option-select-dropdown rounded-3 shadow-lg border-0">
          <Dropdown.ItemText className="d-flex align-items-center gap-2 user-dropdown-item">
            <FaRegCircleUser size="1.2rem" className="d-lg-none"/>
            <span>{user?.given_name + " " + user?.family_name}</span>
          </Dropdown.ItemText>

          <Dropdown.Divider/>
          {isAdmin && (
            <>
              <Dropdown.Item onClick={() => setShowReport(true)}>
                <HiOutlineChartPie size="1.8rem" /> Reports
              </Dropdown.Item>
              <Dropdown.Divider />
            </>
          )}

          <Dropdown className="d-lg-none" show={isHelpOpen} onToggle={(nextShow) => setIsHelpOpen(nextShow)}>
            <Dropdown.Toggle 
              variant="info"
              className="rounded-3 me-3 py-1 option-dropdown-toggle d-flex justify-content-between align-items-center px-3 w-100 pb-2"
            >
              <span className="fw-normal d-flex gap-3 help-toggle">
                <BsInfoCircle size="1.4rem" /> Help
              </span>
               {isHelpOpen ? ( <IoIosArrowUp  size="0.9rem" />) : ( <IoIosArrowDown  size="0.9rem" />)}
            </Dropdown.Toggle>

            <Dropdown.Menu className="help-dropdown">
              <Dropdown.Item
                className=""
                href={helpLinks.USER_GUIDE}
                target="_blank"
              >
                <FiBookOpen className="mx-1"/> Hello User Guide
              </Dropdown.Item>
              <Dropdown.Item
                className=""
                href={helpLinks.VIDEO_GUIDE}
                target="_blank"
              >
                <AiOutlinePlayCircle className="mx-1"/>Hello Video Guide
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

         <div className="border-top mb-2 d-lg-none" />
          <Dropdown.Item onClick={logout}>
            <AiOutlinePoweroff size="1.5rem" /> Logout
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default HeaderOptions;

